// extracted by mini-css-extract-plugin
module.exports = {"progressBarContainer":"ProductProblems_progressBarContainer__3paET"};